import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { AlertErrorCode } from '../../ts/helpers/ErrorCodes';
import { IDataSourceInfo } from '../../ts/models/IDataSourceInfo';
import { Set } from '../../ts/models/Set';
import { DataSources } from '../../ts/resources/Datasources';
import { ICheckConnectionResult } from '../../ts/ServerApi/requests/CheckConnectionRequest';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ContentActionNotification, INotificationTranslationIds } from '../../ts/services/ContentActionNotification';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { ServiceLocator } from '../../app/ServiceLocator';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';

function execute(dataSources: Set<IDataSourceInfo>): Promise<IResult>{
  const datasource = dataSources.first();
  const dataSourceIdArray = dataSources.map(ds => ds.id);
  let workbookId = datasource.workbook != null ? datasource.workbook.id : '';
  const dataSourcesToCheck = dataSources.filter((datasource) => datasource.dataConnectionsCount === 1);
  const Datasources = ServiceLocator.get<DataSources>('DataSources');
  const contentActionNotification = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');

  const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.changeExtractDsToLive(),
      actionName: Messages.changeExtractDsToLiveConfirm(),
      message: Messages.changeExtractDsToLiveBody(),
      action: async () => {
        if (dataSourcesToCheck.size() > 0) {
          const results: ICheckConnectionResult[] = await Datasources.checkConnections(dataSourcesToCheck);
          if (!_.all(results, result=>result.succeeded)) {
            const failedCheckConection: IResult = {errors:[]};
            dataSourcesToCheck.each(() => {
              failedCheckConection.errors.push({code:AlertErrorCode.AlertConnectionlessFailure, message:'connection test failed'});
            });
            if(failedCheckConection && failedCheckConection.errors && failedCheckConection.errors.length)
              {
                  contentActionNotification.notifyGenericError(failedCheckConection.errors[0]);
              }
            return Promise.reject(failedCheckConection);
          }
        }
        const changeToLivePromise = Datasources.changeToLive(dataSourceIdArray, workbookId);
        changeToLivePromise
        .then((result: IResult) => {
          contentActionNotification .notifyResult(dataSources,result.errors,notificationTranslationIds());
          return result;
      });
      return changeToLivePromise;
      },

      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px

    });

  return toNativePromise(dialogConfig.result);
}

function notificationTranslationIds(): INotificationTranslationIds {
  return {
    successId: 'changeExtractDsToLiveSuccess',
    errorId: 'changeExtractDsToLiveError'
  };
}

export const ChangeExtractDsToLiveAction = {
    execute
};

export type ChangeExtractDsToLiveAction = typeof ChangeExtractDsToLiveAction;


